import React from 'react';

/**
 * The release this frontend was built for (REACT_APP_RELEASE, baked at build time, the same string the API reports).
 * Small and quiet; it is there so a person can tell which build is live. `release.json` carries it for smoke checks.
 */
export default function ReleaseStamp() {
  const release = (process.env.REACT_APP_RELEASE || '').trim();
  if (!release) return null;
  return (
    <div className="text-gray-500 text-xs mt-2" data-testid="release-stamp">
      Release {release}
    </div>
  );
}
